import React from 'react';
import useFitnessVillageCopy from '../../../../../hooks/useFitnessVillageCopy';
import { IFormUIProps } from '../../Types';
import { SurfaceProp } from '../../../../shared/dfcVillage/style';
import { Field, FieldLabel, FieldWrap, Form, Spinner, SubmitButton } from './style';

type Props = Pick<IFormUIProps, 'form' | 'onSubmit' | 'isLoading'> & SurfaceProp;

/**
 * Create account — step one is email only, exactly as every other theme: the address is checked
 * for existence, then the shared CompleteProfile flow takes over. No new auth here, just a skin.
 */
const SignupForm: React.FC<Props> = ({ form, onSubmit, isLoading, surface }) => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = form;
  const copy = useFitnessVillageCopy().auth;

  return (
    <Form onSubmit={handleSubmit(onSubmit)} noValidate>
      <FieldWrap>
        <FieldLabel surface={surface} htmlFor="dfc-auth-signup-email">
          {copy.email}
        </FieldLabel>
        <Field
          surface={surface}
          hasError={!!errors.email}
          id="dfc-auth-signup-email"
          dir="ltr"
          type="email"
          autoComplete="email"
          placeholder={copy.emailPlaceholder}
          aria-invalid={!!errors.email}
          data-testid="email-input"
          {...register('email')}
        />
      </FieldWrap>

      <SubmitButton
        surface={surface}
        type="submit"
        disabled={isLoading}
        aria-busy={isLoading}
        data-testid="submit-button"
      >
        {isLoading ? <Spinner surface={surface} /> : copy.signUp.cta}
      </SubmitButton>
    </Form>
  );
};

export default SignupForm;
